import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "email-phone-options-dropdown" }

import {ref} from "vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactsEmailPhoneOptionsDropdown',
  props: {
    type: {}
  },
  emits: ["on-call", "on-email", "on-copy"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const $tooltip = ref<typeof AppTooltip | null>(null)

const onCopy = () => {
	emit('on-copy')
	$tooltip.value?.showByClick()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.type === 'phone')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "email-phone-options-dropdown__item",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('on-call')))
        }, [
          _createVNode(AppIcon, {
            name: "phone",
            width: "14px",
            color: "#979797"
          }),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "email-phone-options-dropdown__item-text" }, " Позвонить ", -1))
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "email-phone-options-dropdown__item",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('on-email')))
        }, [
          _createVNode(AppIcon, {
            name: "envelope",
            width: "14px",
            color: "#979797"
          }),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "email-phone-options-dropdown__item-text" }, " Написать ", -1))
        ])),
    _createVNode(AppTooltip, {
      ref_key: "$tooltip",
      ref: $tooltip,
      text: `${props.type === 'email' ? 'Email' : 'Телефон'} успешно скопирован`,
      position: "bottom",
      "show-by-activator-click": ""
    }, {
      activator: _withCtx(() => [
        _createElementVNode("div", {
          class: "email-phone-options-dropdown__item",
          onClick: onCopy
        }, [
          _createVNode(AppIcon, {
            name: "copy",
            width: "14px",
            color: "#979797"
          }),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "email-phone-options-dropdown__item-text" }, " Копировать ", -1))
        ])
      ]),
      _: 1
    }, 8, ["text"])
  ]))
}
}

})